export default __webpack_public_path__ + "static/media/eye-close.8e1ed365.svg";